/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  GetSyndigoSyncStatusQueryResponse,
  GetSyndigoSyncStatus400,
} from '../../types/GetSyndigoSyncStatus'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getSyndigoSyncStatus } from '../../clients/getSyndigoSyncStatus'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getSyndigoSyncStatusQueryKey = () =>
  [{ url: '/api/v1/products/catalog/variants/syndigo/sync-status/' }] as const

export type GetSyndigoSyncStatusQueryKey = ReturnType<
  typeof getSyndigoSyncStatusQueryKey
>

export function getSyndigoSyncStatusQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = getSyndigoSyncStatusQueryKey()
  return queryOptions<
    GetSyndigoSyncStatusQueryResponse,
    ResponseErrorConfig<GetSyndigoSyncStatus400>,
    GetSyndigoSyncStatusQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getSyndigoSyncStatus({
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @description Get Syndigo sync status information.
 * GET /variants/syndigo/sync-status/
 * Returns:
 * Response with sync status data including:
 * - status: Current sync status
 * - lastSyncAt: Timestamp of most recent sync
 * - lastFullSyncAt: Timestamp of most recent full sync
 * - lastIncrementalOrSingleSyncAt: Timestamp of most recent incremental/single sync
 * @summary Get Syndigo sync status
 * {@link /api/v1/products/catalog/variants/syndigo/sync-status/}
 */
export function useGetSyndigoSyncStatus<
  TData = GetSyndigoSyncStatusQueryResponse,
  TQueryData = GetSyndigoSyncStatusQueryResponse,
  TQueryKey extends QueryKey = GetSyndigoSyncStatusQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetSyndigoSyncStatusQueryResponse,
        ResponseErrorConfig<GetSyndigoSyncStatus400>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getSyndigoSyncStatusQueryKey()

  const query = useQuery(
    {
      ...getSyndigoSyncStatusQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<GetSyndigoSyncStatus400>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
